import React from "react";
import { Card, Row, Col, Form, Button, Spinner } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";

const OcurrenciasFiltros = ({ filtros, setFiltros, empleados, onBuscar, loading, limpiarFiltros }) => {
    return (
        <Card className="mb-4">
            <Card.Header className="bg-light">
                <h6 className="mb-0">
                    <FaFilter className="me-2" />
                    Filtros
                </h6>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>Periodo *</Form.Label>
                            <Form.Select
                                value={filtros.periodo}
                                onChange={(e) => setFiltros({ ...filtros, periodo: e.target.value })}
                            >
                                <option value="">Seleccionar período</option>
                                {(() => {
                                    const currentYear = new Date().getFullYear();
                                    const periods = [];
                                    for (let year = currentYear; year >= currentYear - 2; year--) {
                                        for (let month = 12; month >= 1; month--) {
                                            const monthStr = month.toString().padStart(2, "0");
                                            const periodValue = `${year}-${monthStr}`;
                                            const monthNames = [
                                                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                                                "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre",
                                            ];
                                            periods.push(
                                                <option key={periodValue} value={periodValue}>
                                                    {monthNames[month - 1]} {year}
                                                </option>
                                            );
                                        }
                                    }
                                    return periods;
                                })()}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group>
                            <Form.Label>Empleado</Form.Label>
                            <Form.Select
                                value={filtros.empleado_id}
                                onChange={(e) => setFiltros({ ...filtros, empleado_id: e.target.value })}
                            >
                                <option value="">Todos los empleados</option>
                                {empleados.map((emp) => (
                                    <option key={emp.id} value={emp.dni}>
                                        {emp.nombres} {emp.apellidos}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>Tipo</Form.Label>
                            <Form.Select
                                value={filtros.tipo}
                                onChange={(e) => setFiltros({ ...filtros, tipo: e.target.value })}
                            >
                                <option value="">Todos</option>
                                <option value="falta">Faltas</option>
                                <option value="tardanza">Tardanzas</option>
                                <option value="permiso">Permisos</option>
                                <option value="vacaciones">Vacaciones</option>
                                <option value="descanso_medico">Descanso Médico</option>
                                <option value="licencia">Licencias</option>
                                <option value="he_25">Horas Extras 25%</option>
                                <option value="he_35">Horas Extras 35%</option>
                                <option value="he_100">Horas Extras 100%</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>Estado</Form.Label>
                            <Form.Select
                                value={filtros.estado}
                                onChange={(e) => setFiltros({ ...filtros, estado: e.target.value })}
                            >
                                <option value="">Todos</option>
                                <option value="pendiente">Pendiente</option>
                                <option value="aprobado">Aprobado</option>
                                <option value="rechazado">Rechazado</option>
                                <option value="detectado_automatico">Automático</option>
                                <option value="manual">Manual</option>
                                <option value="manual_importado">Importado Excel</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={2}>
                        <Form.Group>
                            <Form.Label>Justificado</Form.Label>
                            <Form.Select
                                value={filtros.justificado}
                                onChange={(e) => setFiltros({ ...filtros, justificado: e.target.value })}
                            >
                                <option value="">Todos</option>
                                <option value="true">Justificado</option>
                                <option value="false">No Justificado</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    <Col md={1} className="d-flex align-items-end">
                        <Button variant="outline-secondary" onClick={limpiarFiltros}>
                            Limpiar
                        </Button>
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col>
                        <Button
                            variant="primary"
                            onClick={onBuscar}
                            disabled={!filtros.periodo || loading}
                        >
                            {loading ? <Spinner size="sm" className="me-2" /> : null}
                            Buscar
                        </Button>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default OcurrenciasFiltros;
